import React from 'react';
import Svg, { Circle, Line } from 'react-native-svg';

import { COLORS } from '../../config/colors';

type LocationIconProps = {
  color?: string;
};

const LocationIcon = ({ color = COLORS.primary }: LocationIconProps) => {
  return (
    <Svg width={22} height={22} viewBox="0 0 24 24" fill="none">
      <Circle cx={12} cy={12} r={5} stroke={color} strokeWidth={2} />
      <Circle cx={12} cy={12} r={2} fill={color} />
      <Line x1={12} y1={1} x2={12} y2={5} stroke={color} strokeWidth={2} strokeLinecap="round" />
      <Line x1={12} y1={19} x2={12} y2={23} stroke={color} strokeWidth={2} strokeLinecap="round" />
      <Line x1={1} y1={12} x2={5} y2={12} stroke={color} strokeWidth={2} strokeLinecap="round" />
      <Line x1={19} y1={12} x2={23} y2={12} stroke={color} strokeWidth={2} strokeLinecap="round" />
    </Svg>
  );
};

export default LocationIcon;